module.exports = __webpack_public_path__ + "static/media/icon_arrow_wap.19637bc2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/icon_arrow_wap.svg
// module id = 73
// module chunks = 0